/**
 *  A candidate for common component.
 */
import React, { JSX, useState } from 'react';
import { viewport } from '../../utils/utils';
import Styles from './AutoComplete.module.scss';
import { fetchLineCheck } from './LinecheckService';

// eslint-disable-next-line max-lines-per-function
const AutoComplete = React.forwardRef<HTMLInputElement, any>(
  // eslint-disable-next-line max-lines-per-function
  (props, ref:any): JSX.Element => {
    const {
      inputValue,
      setInputValue,
      dropdownValue: suggestions,
      placeholder,
      onChange,
      name,
      inputClassName,
      selectedData,
      minLength,
      maxLength,
      content,
      setApiError,
      setFetchingLineCheck,
      checkAvailability,
      FetchingLineCheck,
      setaddressNotFound
      
    } = props;
    const [activeSuggestion, seActiveSuggestion] = useState(-1);
    const [formDisable, setFormDisable]=useState<boolean>(true)
    const [showSuggestions, setShowSuggestions] = useState(false);
    const viewPort = viewport();
    /**
     * For selecting data when clicked on selected dropdown option
     * @param data : object
     * @param e : mouse selection event.
     * @returns void
     */
    const onSelection = (data: any, e: any): void => {
      seActiveSuggestion(-1);
      setShowSuggestions(false);
      setFormDisable(true);
      setInputValue(e?.currentTarget && e?.currentTarget?.innerText);
      selectedData(data);
    };
    /**
     * For selecting value from dropdown using keyboard event up, down and enter
     * @param e : keyboard up and down and enter evetns
     * @returns void
     */
    const onKeyDown = (e: any): void => {
      if (suggestions && Object.keys(suggestions).length > 0) {
        // User pressed the enter key
        if (e?.key === 'Enter' || e?.keyCode === 13) {
          if (activeSuggestion === -1) return;
          seActiveSuggestion(-1);
          setFormDisable(true)
          setShowSuggestions(false);
          setInputValue(suggestions[activeSuggestion].concatedAddress);
          selectedData(suggestions[activeSuggestion]);
        }
        // User pressed the up arrow
        else if (e?.key === 'ArrowUp' || e?.keyCode === 38) {
          if (activeSuggestion === -1) {
            seActiveSuggestion(suggestions?.length - 1);
            return;
          }
          seActiveSuggestion(activeSuggestion - 1);
        }
        // User pressed the down arrow
        else if (e?.key === 'ArrowDown' || e?.keyCode === 40) {
          if (activeSuggestion === suggestions?.length - 1) {
            seActiveSuggestion(-1);
            return;
          }
          seActiveSuggestion(activeSuggestion + 1);
        } else {
          //For each keystroke other than Enter, Down Arrow and Up Arrow the suggestion must be first index Address
          seActiveSuggestion(-1);
        }
      }
    };
    const handleClick = () => {
      if (!ref?.current?.focus()) {
        setShowSuggestions(false);
      }
       setInputValue('');
       ref?.current?.focus();
       setApiError(false)
       setFetchingLineCheck(false)
       setaddressNotFound(false)
     };
    /**
     * Set the showSuggestion true or false based on object.
     */
    React.useEffect(() => {
      if (suggestions && suggestions.length > 0 && inputValue?.length >= 3) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }, [suggestions]);
  
    return (
      <>
        <div id='dropdownselect' className={`${Styles['inputcontainer']} form-floating ${FetchingLineCheck && Styles['box-disabled']}`}>
          <input
            type='text'
            disabled={FetchingLineCheck || !formDisable || checkAvailability}
            placeholder={placeholder}
            onChange={onChange}
            name={name}
            onKeyDown={onKeyDown}
            value={inputValue}
            autoComplete='off'
            aria-autocomplete='none'
            className={inputClassName}
            spellCheck='false'
            minLength={minLength}
            maxLength={maxLength}
          />
          <label htmlFor='address' className='input-label'>
            {placeholder}
          </label>
          {!(FetchingLineCheck || !formDisable || checkAvailability) && inputValue?.length !== 0 && <div className={Styles['cross-icon']} onClick={handleClick}> 
             <img src={content?.linecheckIcons?.[0]?.close?.filename} height={14} width={14} alt='cross-icon'/>
             </div>}
          {showSuggestions && suggestions?.length && (
            <ul className={Styles['addresscontainer']}>
              {suggestions.map((suggestion: any, index: number) => {
                let activeClass;

                // Flag the active suggestion with a class
                if (index === activeSuggestion) {
                  activeClass = 'active';
                }

                return (
                  <>
                  <li  className={activeClass ==='active'? Styles[`suggestionactive`]:Styles['suggestionInactive']}
                   key={index} onClick={(e) => onSelection(suggestion, e)}>
                    {suggestion && suggestion.concatedAddress}
                  </li>
                  
                  </>
                );
              })}
            </ul>
          )}
        </div>
      </>
    );
  }
);

export default AutoComplete;
